import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=147c313a&scoped=true&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"
import style0 from "./switcher.vue?vue&type=style&index=0&id=147c313a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c313a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147c313a')) {
      api.createRecord('147c313a', component.options)
    } else {
      api.reload('147c313a', component.options)
    }
    module.hot.accept("./switcher.vue?vue&type=template&id=147c313a&scoped=true&", function () {
      api.rerender('147c313a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/switcher.vue"
export default component.exports